import React from 'react'
import { getTenantById, DEFAULT_TENANT_ID } from '../config/tenants'

export const ClientContext = React.createContext({
  tenant: getTenantById(DEFAULT_TENANT_ID),
  /** @deprecated use tenant.id === 'mi-tienda' */
  isMiTienda: false
})
